// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ChevronDownComponent} from './ChevronDown.svg';

import Icon, { TIconProps } from '../Icon';

export const IconChevronDown = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ChevronDownComponent/>
  </Icon>
));
